<div class="dialog">
  <img [src]="'/assets/animations/product-icons/' + feature.product + '.svg'" alt="" />
  <div class="label label-primary">UPGRADE</div>
  <h1>{{ feature.title }}</h1>
  <p>{{ feature.description }}</p>
  <a
    [routerLink]="['/a', 'pricing']"
    [queryParams]="feature.product === 'pro' ? { product: feature.product } : undefined"
    appButton
    name="confirm"
    location="feature-paywall-dialog"
    [analyticsExtra]="{ feature: feature.key }"
    [color]="colors[feature.product]"
    weight="bold"
    shape="round"
    height="4"
    spacing="5"
    shape="round"
    size="3"
    [center]="true"
  >
    @if (canStartTrial) {
      Start Free Trial
    }
    @if (!canStartTrial) {
      Upgrade Now
    }
  </a>
</div>
